// extracted by mini-css-extract-plugin
module.exports = {"columnTableHead":"dataTable_columnTableHead__27CJI"};